module.exports = __webpack_public_path__ + "static/media/tapFX-1.124b3f4e.wav";